import React from 'react';

const Logo = () => {
  return (
    <div className="app-logo animate-pulse-slow" aria-hidden="true">
      <div className="heart"></div>
      <div className="inner-heart animate-heartbeat-slow"></div>
      <div className="shine"></div>
    </div>
  );
};

export default Logo;